import { render, staticRenderFns } from "./compinfo.vue?vue&type=template&id=381e384c&scoped=true&"
import script from "./compinfo.vue?vue&type=script&lang=js&"
export * from "./compinfo.vue?vue&type=script&lang=js&"
import style0 from "./compinfo.vue?vue&type=style&index=0&id=381e384c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381e384c",
  null
  
)

export default component.exports